import { Component, OnInit } from '@angular/core';
import { CurrentDataService } from '../../../services/current-data-service';
import { Transporter } from '../../../models/transporter.model';
import { ThemeView } from '../../../models/theme-view.model';
import { CarouselItem } from '../../../models/carousel-item.model';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { combineLatest } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { TransporterEnum } from '../../../models/enums/transporter-enum.enum';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'jhi-home',
  styleUrls: ['./home.component.scss'],
  templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit {
  public transporter: Transporter | undefined;
  public environment = environment;
  public logo: string = '/api/img/logo-splash';
  public theme?: ThemeView;
  public slides: CarouselItem[] = [];
  public mainJumbotronMessage!: SafeHtml;
  public carouselOptions: OwlOptions = {
    loop: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    navText: ['<', '>'],
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 2,
      },
      740: {
        items: 3,
      },
      940: {
        items: 3,
      },
    },
    nav: true,
  };
  private cookiesPolicyLink = '';

  constructor(private _sanitizer: DomSanitizer, protected currentDataService: CurrentDataService, private translateService: TranslateService) {
    combineLatest([this.currentDataService.getCurrentTransporter(), this.currentDataService.getCurrentTheme()]).subscribe({
      next: (data: any): void => {
        this.transporter = data[0];
        if (data[1]) {
          this.theme = data[1];
          this.slides = data[1].themeData!.carouselItems;
          this.mainJumbotronMessage = this._sanitizer.bypassSecurityTrustHtml(data[1].themeData!.mainJumbotronContent);
        }
      },
    });
  }

  public ngOnInit(): void {
    this.cookiesPolicyLink = new URL(window.location.href).origin + '/cookies';
    this.scrollToTop();
  }

  scrollToTop(): void {
    const scrollTop = (): void => {
      const c = document.documentElement.scrollTop || document.body.scrollTop;
      if (c > 0) {
        // window.requestAnimationFrame(scrollTop);
        window.scrollTo(0, c - c / 4);
      }
    };
    scrollTop();
  }

  getCopyrightMessage(): string {
    let message = '';
    const year = new Date().getFullYear().toString();
    if (this.theme?.themeData?.copyrightLegalMentionsLink) {
      message += '<a href="' + this.theme.themeData.copyrightLegalMentionsLink + '">' + this.translateService.instant('baryApp.themeData.legalNotices') + '</a> - ';
    }

    message += '<a href="' + this.cookiesPolicyLink + '" target="_blank">' + this.translateService.instant('baryApp.themeData.cookiesPolicy') + '</a> | ';
    message += this.translateService.instant('baryApp.themeData.copyrightMessage', { companyName: this.transporter?.companyName, year: year });
    message += '<br/>';
    message += '<a href=\'https://www.bary.app/\' target="_blank"  >' + this.translateService.instant('baryApp.themeData.copyrightPoweredByBary') + '</a>';

    return message;
  }

  protected readonly Transporter = Transporter;
  protected readonly TransporterEnum = TransporterEnum;
}
